"use strict";

module.exports = function () {
  this.data.forEach(function (row, index) {
    this.opts.dateColumns.forEach(function (column) {
      row[column] = moment(row[column], this.opts.toMomentFormat);
    }.bind(this));
  }.bind(this));
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/transform-date-strings-to-moment.js